// extracted by mini-css-extract-plugin
export default {"displayHorizontal":"CraftingRow_displayHorizontal__GMjbt","centerHorizontal":"CraftingRow_centerHorizontal__z9Aa3"};